import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import styles from './reviews.module.scss';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { ReviewsTransFields } from './types';
import { reviewsTranslations } from './translations';
import ReviewsTable from 'components/Tables/ReviewsTable/ReviewsTable';
import { useQuery } from 'react-query';
import { useStore } from 'hooks/useRootStore';
import { AppLoader } from 'components/Core/AppLoader';

const Reviews: FC = observer(() => {
  const { t } = useMyTranslations<ReviewsTransFields>([reviewsTranslations.name]);

  const {
    reviewsStore: { getReviewsData },
  } = useStore();

  const { isFetching } = useQuery('getReviews', () => getReviewsData(), {
    refetchOnWindowFocus: false,
  });

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h2 className={styles.headerTitle}>{t('title')}</h2>
      </header>

      <div className={styles.container}>{isFetching ? <AppLoader /> : <ReviewsTable />}</div>
    </main>
  );
});

export default Reviews;
